import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { environment } from '../../environments/environment';

interface AuthRequestResponse {
  isAuthenticated: boolean;
}

interface LogoutRequestResponse {
  status: string;
}

@Injectable({
  providedIn: 'root'
})
export class Auth {
  private baseUrl = environment.apiUrl;
  
  private http = inject(HttpClient);

  public authenticateUser(username: string, password: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.post(`${this.baseUrl}/api/auth/login_user/`,
        {'username': username, 'password': password},
        {observe: 'response', withCredentials: true}).subscribe({
        next: res => {
          if (res.status === 200) {
            resolve(true);
          } else if (res.status === 401) {
            resolve(false);
          }
          // Error case - Something went wrong with the request
          reject();
        },
        error: err => { reject(err); }})
    })
  }

  public logoutUser(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.get<LogoutRequestResponse>(`${this.baseUrl}/api/auth/logout_user/`,
        {withCredentials: true}).subscribe(
          res => {
            resolve(res.status === "success");
          })
        })
  }

  /**
   * Check user authentication status.
   */
  public isAuthenticated(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.get<AuthRequestResponse>(`${this.baseUrl}/api/auth/login_user/`, {withCredentials: true})
        .subscribe(res => {
          resolve(res.isAuthenticated);
        })
    })
  }
}
